import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { store } from '../../store';
import { t } from '../../i18n';
import { icon } from '../ui/icons';

/** <cadence-break-banner> — a "Break period" notice shown on dashboards during a
 *  configured break month (Phase 5.7). Renders nothing outside a break month.
 *  Break status comes from the session payload (store.breakPeriod). */
@customElement('cadence-break-banner')
export class CadenceBreakBanner extends LitElement {
  private unsub?: () => void;

  static styles = css`
    :host { display: block; }
    .banner {
      display: flex; align-items: center; gap: 10px;
      padding: 12px 16px; margin-bottom: var(--space-4);
      border: 1px solid var(--color-warning, #d97706);
      background: color-mix(in srgb, var(--color-warning, #d97706) 10%, transparent);
      border-radius: var(--radius-md); color: var(--color-text-primary);
    }
    .banner svg { width: 18px; height: 18px; color: var(--color-warning, #d97706); flex-shrink: 0; }
    .banner strong { font-weight: 600; }
    .banner .sub { color: var(--color-text-secondary); font-size: 0.9rem; }
  `;

  connectedCallback(): void {
    super.connectedCallback();
    this.unsub = store.subscribe(() => this.requestUpdate());
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.unsub?.();
  }

  render() {
    if (!store.get().breakPeriod) return null;
    return html`
      <div class="banner" role="status">
        ${icon('clock', 18)}
        <span><strong>${t('common.break.notice')}</strong> <span class="sub">${t('common.break.body')}</span></span>
      </div>`;
  }
}
